import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Bloqueia a rota conforme o tipo de sessão.
 * - padrão: exige usuário de escritório logado
 * - somenteProprietario: além disso, exige papel de proprietário
 * - somenteAdmin: exige sessão do administrador do sistema
 */
const RotaProtegida = ({ children, somenteProprietario = false, somenteAdmin = false }) => {
    const { autenticado, adminAutenticado, ehProprietario } = useAuth();

    if (somenteAdmin) {
        return adminAutenticado ? children : <Navigate to="/login" replace />;
    }

    if (!autenticado) {
        // Admin logado caiu numa rota de escritório: manda pro painel dele
        return <Navigate to={adminAutenticado ? "/admin" : "/login"} replace />;
    }

    if (somenteProprietario && !ehProprietario) {
        return <Navigate to="/inicio" replace />;
    }

    return children;
};

export default RotaProtegida;
